export const LOG = 'LOG';
export const LOG_IN = 'LOG_IN';
export const SET_DISPLAY = 'SET_DISPLAY';
export const INIT_DATABASE = 'INIT_DATABASE';

export const SET_FOCUSED_ISLAND = 'SET_FOCUSED_ISLAND';